/**
 * Payment configuration constants for EcoCash transactions.
 * These values coordinate timeout behavior between frontend and backend.
 */

// API timeout for initial payment request (2 minutes)
// This is the maximum time to wait for the backend to initiate the EcoCash prompt
export const ECOCASH_API_TIMEOUT = 120000;

// Polling interval when checking payment status (5 seconds)
export const ECOCASH_POLL_INTERVAL = 5000;

// Maximum duration to poll for payment confirmation (30 seconds)
// After this, we show a timeout state with options to retry or contact support
export const ECOCASH_MAX_POLL_DURATION = 30000;

// Time after which to show the cancel button during loading (15 seconds)
export const ECOCASH_SHOW_CANCEL_AFTER = 15000;

// Human-readable timeout message
export const ECOCASH_TIMEOUT_MESSAGE = "We're still waiting for payment confirmation from EcoCash. This is taking longer than expected.";

// Export as a single config object for convenience
const paymentConfig = {
	ECOCASH_API_TIMEOUT,
	ECOCASH_POLL_INTERVAL,
	ECOCASH_MAX_POLL_DURATION,
	ECOCASH_SHOW_CANCEL_AFTER,
	ECOCASH_TIMEOUT_MESSAGE,
};

export default paymentConfig;
